import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Auth0Provider } from '@auth0/auth0-react';
import { AuthProvider } from './contexts/AuthContext';
import logger from './logging/logger';
import { initFaro } from './logging/faro';

// Initialize Faro before rendering so it captures early errors/logs
initFaro();

logger.info('Auth0 configuration loaded', {
  domain: process.env.REACT_APP_AUTH0_DOMAIN || '',
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID || '',
  audience: process.env.REACT_APP_AUTH0_AUDIENCE || '',
  redirectUri: window.location.origin,
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <Auth0Provider
      domain={process.env.REACT_APP_AUTH0_DOMAIN || 'undefined'}
      clientId={process.env.REACT_APP_AUTH0_CLIENT_ID || 'undefined'}
      authorizationParams={{
        redirect_uri: `${window.location.origin}/home`,
        audience: process.env.REACT_APP_AUTH0_AUDIENCE,
        scope: 'openid profile email'
      }}
      cacheLocation="localstorage"
      useRefreshTokens={true}
      onRedirectCallback={(appState) => {
        logger.info('Auth0 redirect callback completed', {
          currentUrl: window.location.href,
          returnTo: appState?.returnTo || '',
        });
        // Only redirect if not logging out
        if (!window.location.href.includes('logout')) {
          window.history.replaceState({}, document.title, appState?.returnTo || '/home');
        }
      }}
    >
      <AuthProvider>
        <App />
      </AuthProvider>
    </Auth0Provider>
  </React.StrictMode>
);